// extracted by mini-css-extract-plugin
export default {"section-container":"styles__section-container--LvcWk","section-children-container":"styles__section-children-container--n-cTu"};